import { render, staticRenderFns } from "./TableCellTypeCurrency.vue?vue&type=template&id=60d31feb&scoped=true"
import script from "./TableCellTypeCurrency.vue?vue&type=script&lang=js"
export * from "./TableCellTypeCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d31feb",
  null
  
)

export default component.exports